import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import DesktopSwitcher from '../DesktopSwitcher';
import ChangeLang from '../MenuList/ChangeLang';
import CONFIG from '../../config';

const Footer = ({ isTabBarExist, isBackgroundWhite }) => {
  const { t, i18n } = useTranslation();
  const {
    contacts: { tel, tel_url: telUrl, email, instagramLink, facebookLink },
    currentYear
  } = CONFIG;

  return (
    <footer
      className={cn('footer', {
        'footer--with-indent': isTabBarExist,
        'footer--white-background': isBackgroundWhite
      })}
    >
      <div className="footer__blk" data-cy="footer-top">
        <a
          href="/pages/about"
          className="footer__link footer__link--pages"
          data-cy="footer-link-pages"
        >
          {t('footer.about')}
        </a>
        <a
          href="/pages/terms-and-conditions"
          className="footer__link  footer__link--pages"
          data-cy="footer-link-pages"
        >
          {t('footer.agreement')}
        </a>
        <a
          href="/pages/privacy"
          className="footer__link footer__link--pages"
          data-cy="footer-link-pages"
        >
          {t('footer.privacy')}
        </a>
        <a
          href="/pages/advertise"
          className="footer__link footer__link--pages"
          data-cy="footer-link-pages"
        >
          {t('footer.advertise')}
        </a>
      </div>
      <div
        className="footer__blk"
        itemScope=""
        itemType="http://schema.org/Organization"
      >
        <a
          itemProp="telephone"
          href={telUrl}
          className="footer__link footer__link--contact"
          data-cy="footer-link-phone"
        >
          {tel}
        </a>
        <p
          itemProp="openingHours"
          className="footer__opening-hours"
          data-cy="footer-opening-hours"
        >
          {t('footer.opening_hours')}
          <meta itemProp="openingHours" content="Mo-Fr 09:00-18:00" />
        </p>
        <a
          itemProp="email"
          href={`mailto:${email}`}
          className="footer__link footer__link--social"
          data-cy="footer-link-social"
        >
          <i className="footer__link--social_icon footer__link--social_icon--email" />
        </a>
        <a
          href={facebookLink}
          className="footer__link footer__link--social"
          target="_blank"
          rel="noopener noreferrer"
          data-cy="footer-link-social"
        >
          <i className="footer__link--social_icon footer__link--social_icon--facebook" />
        </a>
        <a
          href={instagramLink}
          className="footer__link footer__link--social"
          target="_blank"
          rel="noopener noreferrer"
          data-cy="footer-link-social"
        >
          <i className="footer__link--social_icon footer__link--social_icon--instagram" />
        </a>
      </div>
      <div className="footer__blk" data-cy="footer-bottom">
        <a
          href="/pages/sitemap"
          className="footer__link footer__link--inline"
          data-cy="footer-link-inline"
        >
          {t('footer.sitemap')}
        </a>
        <DesktopSwitcher className="footer__link footer__link--inline desktop-switcher" />
        <ChangeLang
          i18n={i18n}
          t={t}
          className="footer__link footer__link--inline"
        />
        <div className="footer__info" data-cy="footer-info">
          {t('footer.info')}
        </div>
        <div className="footer__copyright" data-cy="footer-copyright">
          {`© 2008-${currentYear} Digital Classifieds MMC.`}
          <br />
          {'VÖEN: 1405631661'}
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  isTabBarExist: PropTypes.bool,
  isBackgroundWhite: PropTypes.bool
};

export default Footer;
